import { render } from "./Feedback.vue?vue&type=template&id=37576f97&scoped=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=37576f97&lang=scss"
import "./Feedback.vue?vue&type=style&index=1&id=37576f97&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=2&id=37576f97&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37576f97"]])

export default __exports__